import { useState, useEffect } from 'react';
import { PieChart as PieChartIcon } from 'lucide-react';
import { CalculatorCard, SliderInput } from '../CalculatorCard';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

export const BudgetCalculator = () => {
  const [income, setIncome] = useState(50000);
  const [needs, setNeeds] = useState(0);
  const [wants, setWants] = useState(0);
  const [savings, setSavings] = useState(0);

  useEffect(() => {
    setNeeds(Math.round(income * 0.5));
    setWants(Math.round(income * 0.3));
    setSavings(Math.round(income * 0.2));
  }, [income]);

  const pieData = [
    { name: 'Potřeby 50%', value: needs, color: '#22C55E' },
    { name: 'Přání 30%', value: wants, color: '#EAB308' },
    { name: 'Spoření 20%', value: savings, color: '#3B82F6' },
  ];

  const result = (
    <div className="space-y-6">
      <div className="text-right">
        <p className="text-gray-400 text-sm">Váš měsíční příjem</p>
        <p className="text-4xl font-bold text-green">{income.toLocaleString('cs-CZ')} Kč</p>
      </div>

      <div className="h-52">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={pieData}
              cx="50%"
              cy="50%"
              innerRadius={50}
              outerRadius={80}
              paddingAngle={3}
              dataKey="value"
            >
              {pieData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between p-3 bg-green/10 rounded-xl">
          <div className="flex items-center gap-3">
            <div className="w-3 h-3 rounded-full bg-green"></div>
            <span className="text-white font-medium">Potřeby (50%)</span>
          </div>
          <span className="text-green font-bold">{needs.toLocaleString('cs-CZ')} Kč</span>
        </div>
        <div className="flex items-center justify-between p-3 bg-gold/10 rounded-xl">
          <div className="flex items-center gap-3">
            <div className="w-3 h-3 rounded-full bg-gold"></div>
            <span className="text-white font-medium">Přání (30%)</span>
          </div>
          <span className="text-gold font-bold">{wants.toLocaleString('cs-CZ')} Kč</span>
        </div>
        <div className="flex items-center justify-between p-3 bg-blue-500/10 rounded-xl">
          <div className="flex items-center gap-3">
            <div className="w-3 h-3 rounded-full bg-blue-500"></div>
            <span className="text-white font-medium">Spoření (20%)</span>
          </div>
          <span className="text-blue-500 font-bold">{savings.toLocaleString('cs-CZ')} Kč</span>
        </div>
      </div>
    </div>
  );

  return (
    <CalculatorCard
      id="budget"
      title="Pravidlo 50/30/20"
      subtitle="Optimální rozdělení rozpočtu"
      icon={PieChartIcon}
      tip="50% na potřeby (bydlení, jídlo, doprava), 30% na přání (zábava, oblečení), 20% na spoření a investice. Pokud potřeby přesahují 50%, hledejte úspory nebo vyšší příjem."
      result={result}
      showResult={true}
      testId="budget-calculator"
    >
      <SliderInput
        label="Čistý měsíční příjem"
        value={income}
        onChange={setIncome}
        min={15000}
        max={200000}
        step={1000}
        suffix="Kč"
        testId="budget-income-slider"
      />
    </CalculatorCard>
  );
};
